export enum BookingInvalidTimeReason {
  PAST_DAY = "PAST_DAY",
  OFFICE_CLOSED = "OFFICE_CLOSED",
  BEYOND_LEAD_TIME = "BEYOND_LEAD_TIME",
  INVALID_TIME = "INVALID_TIME",
  OFFICE_CLOSED_ALL_DAYS = "OFFICE_CLOSED_ALL_DAYS",
  AFTER_CLOSING_TIME = "AFTER_CLOSING_TIME",
  BEFORE_OPENING_TIME = "BEFORE_OPENING_TIME",
}
